import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DirectorySearchFilter} from '../../../shared/types/wsdirectory/directory-search-options';
import {RegionRestService} from '../../../shared/services/region/region-rest.service';

import {Observable} from 'rxjs';
import {OrganizationRestService} from '../../../shared/services/oganization/organization-rest.service';
import {SelectItem} from 'primeng/api';
import {CountryRestService} from '../../../shared/services/common/country-rest.service';
import {ExpertiseAreaRestService} from '../../../shared/services/expertise-area/expertise-area-rest.service';
import {AppointmentTitleRestService} from '../../../shared/services/appointment/appointment-title-rest.service';
import {SystemType} from '../../../shared/types/common/system-type';
import {map} from 'rxjs/operators';

@Component({
  selector: 'wsd-filter-bar',
  templateUrl: './filter-bar.component.html',
  styleUrls: ['./filter-bar.component.css']
})
export class FilterBarComponent implements OnInit {

  @Input()
  filter: DirectorySearchFilter;

  @Input()
  isAuthenticated: boolean;

  regions: Observable<SelectItem[]>;
  organizations: Observable<SelectItem[]>;
  titles: Observable<SelectItem[]>;
  areas: Observable<SelectItem[]>;
  countries: Observable<SelectItem[]>;

  @Output()
  private onChange = new EventEmitter<void>();

  constructor(private regionService: RegionRestService,
              private organizationService: OrganizationRestService,
              private appointmentsService: AppointmentTitleRestService,
              private areaService: ExpertiseAreaRestService,
              private countryService: CountryRestService) {
  }

  ngOnInit() {
    this.regions = this.regionService.getAllRegions(SystemType.NONE).pipe(map(this.toSelectable));
    this.organizations = this.organizationService.getAllOrganizations(SystemType.NONE).pipe(map(this.toSelectable));
    this.titles = this.appointmentsService.getStandardTitles().pipe(map(this.toSelectable));
    this.areas = this.areaService.getExpertiseAreas(250, 0, '').pipe(map(this.toSelectable));
    this.countries = this.countryService.getAllCountries().pipe(map(this.toSelectable));
  }

  change() {
    this.onChange.emit();
  }

  private toSelectable(res): SelectItem[] {
    return (res.content || res).map(obj => {
      return {label: obj.name, value: obj.id};
    });
  }

}
